import type { Recipe, AdminRecipesResponse } from '../../types/api-types.js';
import type { AxiosResponse } from 'axios';
import { xoxoApi, kioskApi, API_KEY } from '../axios.js';
import type { LocalRecipeApiShape, XoxoRecipeApiShape } from '../../types/api-shapes.js';
// Removed duplicate import

export const recipeApi: LocalRecipeApiShape = {
  getAdminRecipes(shopId: string): Promise<AxiosResponse<AdminRecipesResponse>> {
    return kioskApi.get<AdminRecipesResponse>(`/admin/shops/${shopId}/recipes`);
  },
  cacheRecipes(recipes: Recipe[]): Promise<{ message: string }> {
    return kioskApi.post('/admin/recipes/cache', { recipes }).then((res: any) => res.data);
  },
  /**
   * Fetch a single recipe by ID from the kiosk backend
   */
  getRecipeById(recipeId: string): Promise<AxiosResponse<Recipe>> {
    return kioskApi.get<Recipe>(`/admin/recipes/${recipeId}`);
  },
  /**
   * Fetch multiple recipes by their IDs
   */
  getRecipesByIds(recipeIds: string[]): Promise<AxiosResponse<Recipe[]>> {
    return kioskApi.post<Recipe[]>('/admin/recipes/batch', { recipeIds });
  }
};

export const xoxoRecipeApi: XoxoRecipeApiShape = {
  /**
   * Fetches admin recipes from XOXO API using shop name
   * @param shopName - The name of the shop to fetch recipes for
   */
  getAdminRecipes(shopName: string): Promise<AxiosResponse<AdminRecipesResponse>> {
    return xoxoApi.get<AdminRecipesResponse>('/recipe/admin/withDrinkFeature', {
      params: { shopName, apiKey: API_KEY },
    });
  }
};
